export const getFiltersPreferences = state => state.filtersPreferences || {};

export const getFiltersPreference = (state, { key }) => getFiltersPreferences(state)[key];
